import { env } from '@/env.mjs'
import {
	AUTHOR_PAGE_PATH,
	CATEGORY_PAGE_PATH,
	ROOT_APPS_PATH,
	ROOT_BLOG_PAGE_PATH,
	ROOT_CASE_STUDIES_PATH,
	ROOT_PAGE_PATH,
} from '@/lib/constants'
import { routing } from '@/lib/navigation.ts'
import type { AppLocale } from '@/types/general'

const getLocalePath = (locale?: AppLocale) => {
	if (!locale || locale === routing.defaultLocale) {
		return ''
	}

	return `/${locale}`
}
export const getFullUrl = (relativeLink: string | null | undefined) => {
	if (relativeLink == null) {
		return undefined
	}

	if (relativeLink === '/') {
		return env.APP_PUBLIC_URL
	}

	if (relativeLink[0] === '/') {
		return `${env.APP_PUBLIC_URL}${relativeLink}`
	}

	return `${env.APP_PUBLIC_URL}/${relativeLink}`
}

export const getBlogLink = (locale?: AppLocale) => {
	return `${getLocalePath(locale)}${ROOT_BLOG_PAGE_PATH}`
}

export const getBlogPaginationLink = (count?: number | null, locale?: AppLocale) => {
	return `${getLocalePath(locale)}${ROOT_BLOG_PAGE_PATH}/page/${count}`
}

export const getArticleLink = (slug?: string | null, locale?: AppLocale) => {
	if (slug == null) {
		return ''
	}

	return `${getLocalePath(locale)}${ROOT_BLOG_PAGE_PATH}/${slug}`
}

export const getArticleUrl = (slug?: string | null, locale?: AppLocale) => {
	if (slug == null) {
		return ''
	}

	return getFullUrl(getArticleLink(slug, locale))
}

export const getBlogCategoryLink = (slug?: string | null, locale?: AppLocale) => {
	if (slug == null) {
		return ''
	}

	return `${getLocalePath(locale)}${CATEGORY_PAGE_PATH}/${slug}`
}

export const getBlogCategoryUrl = (slug?: string | null, locale?: AppLocale) => {
	if (slug == null) {
		return ''
	}

	return getFullUrl(getBlogCategoryLink(slug, locale))
}

export const getAuthorLink = (slug?: string | null, locale?: AppLocale) => {
	if (slug == null) {
		return ''
	}

	return `${getLocalePath(locale)}${AUTHOR_PAGE_PATH}/${slug}`
}

export const getAuthorUrl = (slug?: string | null, locale?: AppLocale) => {
	if (slug == null) {
		return ''
	}
	return getFullUrl(getAuthorLink(slug, locale))
}

export const getPageLink = (fullPath?: string | null, locale?: AppLocale) => {
	if (fullPath == null || fullPath === '/' || fullPath === ROOT_PAGE_PATH) {
		return ''
	}

	const path = fullPath.replace('index/', '')

	return `${getLocalePath(locale)}/${path}`
}

export const getPageUrl = (fullPath?: string | null, locale?: AppLocale) => {
	if (fullPath == null) {
		return ''
	}

	return getFullUrl(getPageLink(fullPath, locale))
}

export const getCaseStudiesLink = (slug?: string | null, locale?: AppLocale) => {
	if (slug == null) {
		return ''
	}
	return `${getLocalePath(locale)}${ROOT_CASE_STUDIES_PATH}/${slug}`
}

export const getCaseStudiesRootPageLink = (locale?: AppLocale) => {
	return `${getLocalePath(locale)}${ROOT_CASE_STUDIES_PATH}`
}

export const getAppRootLink = (locale?: AppLocale) => {
	return `${getLocalePath(locale)}${ROOT_APPS_PATH}`
}

export const getAppLink = (slug?: string | null, category?: string | null, locale?: AppLocale) => {
	if (slug == null || category == null) {
		return ''
	}
	return `${getLocalePath(locale)}${ROOT_APPS_PATH}/${category}/${slug}`
}

export const getAppCategoryLink = (category?: string | null, locale?: AppLocale) => {
	if (category == null) {
		return ''
	}
	return `${getLocalePath(locale)}${ROOT_APPS_PATH}/${category}`
}
